import React from 'react';
import { Zap, TrendingUp, DollarSign, Leaf, ArrowRight } from 'lucide-react';
export function HeroSection() {
  const stats = [{
    icon: Zap,
    value: '5000 GWh',
    label: 'Clean Electricity Production'
  }, {
    icon: TrendingUp,
    value: '85%+',
    label: 'Efficiency (vs <65% traditional)'
  }, {
    icon: DollarSign,
    value: 'Up to $30M',
    label: 'Savings for Cities'
  }, {
    icon: Leaf,
    value: '$1M',
    label: 'Carbon Credits per 50k tonnes'
  }];
  return <section id="hero" className="relative pt-32 pb-20 lg:pt-48 lg:pb-32 overflow-hidden" data-id="element-106">
      {/* Background Image */}
      <div className="absolute inset-0 z-0" data-id="element-107">
        <img src="https://cdn.magicpatterns.com/uploads/xs3FNRVmAJVyjcqUEfuovH/Renewables-Application.jpg" alt="Renewable energy infrastructure" className="w-full h-full object-cover opacity-20" data-id="element-108" />
        <div className="absolute inset-0 bg-gradient-to-b from-slate-950/80 via-slate-950/90 to-slate-950" data-id="element-109"></div>
      </div>

      {/* Background Gradients */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full h-full max-w-7xl pointer-events-none" data-id="element-110">
        <div className="absolute top-20 left-1/4 w-96 h-96 bg-emerald-600/20 rounded-full blur-[120px]" data-id="element-111"></div>
        <div className="absolute top-40 right-1/4 w-96 h-96 bg-cyan-600/10 rounded-full blur-[120px]" data-id="element-112"></div>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-113">
        <div className="text-center max-w-4xl mx-auto mb-16" data-id="element-114">
          <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-emerald-500/10 border border-emerald-500/20 text-emerald-400 text-sm font-medium mb-8" data-id="element-115">
            <span className="relative flex h-2 w-2" data-id="element-116">
              <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-emerald-400 opacity-75" data-id="element-117"></span>
              <span className="relative inline-flex rounded-full h-2 w-2 bg-emerald-500" data-id="element-118"></span>
            </span>
            Now Raising Seed Round
          </div>

          <h1 className="text-5xl md:text-7xl font-extrabold text-white tracking-tight mb-8 leading-[1.1]" data-id="element-119">
            Turn Waste Into <br data-id="element-120" />
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-emerald-400 to-cyan-400" data-id="element-121">
              Clean Energy
            </span>
          </h1>

          <p className="text-xl text-slate-300 mb-10 leading-relaxed max-w-3xl mx-auto" data-id="element-122">
            Green Fuel converts methane waste into electricity and hydrogen
            using AI-powered bio-digesters — reducing emissions, cutting costs,
            and powering the future.
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-4" data-id="element-123">
            <a href="#contact" className="w-full sm:w-auto px-8 py-4 text-base font-bold text-white bg-emerald-600 rounded-full hover:bg-emerald-500 transition-all hover:shadow-[0_0_30px_rgba(16,185,129,0.3)]" data-id="element-124">
              Partner With Us
            </a>
            <a href="#gotomarket" className="w-full sm:w-auto inline-flex items-center justify-center px-8 py-4 text-base font-bold text-white bg-slate-800 border border-slate-700 rounded-full hover:bg-slate-700 hover:border-slate-600 transition-all group" data-id="element-125">
              View Pilot Program
              <ArrowRight className="ml-2 w-5 h-5 group-hover:translate-x-1 transition-transform" data-id="element-126" />
            </a>
          </div>
        </div>

        {/* Stats Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mt-20" data-id="element-127">
          {stats.map((stat, index) => {
          const Icon = stat.icon;
          return <div key={index} className="bg-slate-900/50 backdrop-blur-sm border border-slate-800 rounded-2xl p-6 hover:border-emerald-500/30 transition-all duration-300 hover:-translate-y-1 group" data-id="element-128">
                <div className="w-12 h-12 rounded-xl bg-slate-800 flex items-center justify-center mb-4 group-hover:bg-emerald-500/20 transition-colors" data-id="element-129">
                  <Icon className="w-6 h-6 text-emerald-400" data-id="element-130" />
                </div>
                <div className="text-3xl font-bold text-white mb-2" data-id="element-131">
                  {stat.value}
                </div>
                <div className="text-sm text-slate-400 font-medium" data-id="element-132">
                  {stat.label}
                </div>
              </div>;
        })}
        </div>
      </div>
    </section>;
}